import print from 'vue3-print-nb'
// import permission from './permission.js'

export default app => {
  app.use(print) // 别人创建好的插件，包含指令与其自动安装的初始代码，所以直接使用
  // app.directive('permission', permission)// 自建指令
}
